import React, { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  CircularProgress
} from '@mui/material';
import { Close as CloseIcon, Upload as UploadIcon } from '@mui/icons-material';
import { addJustification, addJustificationByHR } from '../../services/absenceAPIs';
import {addLeaveJustificationByHR} from '../../services/leavesAPIs';
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const JustificationUploadModal = ({ selectedUpload, setSelectedUpload, fetchAbsences, leave=false, fetchData }) => {
  const [reason, setReason] = useState('');
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');


  

  useEffect(() => {
    if (!leave && selectedUpload?.reason) {
      setReason(selectedUpload.reason);
    } else if( leave && selectedUpload?.justification ) {
      setReason(selectedUpload.justification);
    } else {
      setReason('');
    }
  }, [selectedUpload]);


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!reason.trim()) {
      setError("Reason is required");
      return;
    }

    try {
      setSubmitting(true);
      if (leave){
        await addLeaveJustificationByHR(selectedUpload.requestId, file);
      }
      else {
        await addJustificationByHR(selectedUpload.id, reason, file);
      }

      if(leave) {
        fetchData();
      } else {
        fetchAbsences(); // Refresh data
      }
        
      setSelectedUpload(null); // Close modal
    } catch (err) {
      console.error(err);
      setError("Failed to upload justification");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSelectedUpload(null);
  };

  return (
    <Modal open={!!selectedUpload} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6">Upload Justification</Typography>
          <IconButton onClick={handleClose}><CloseIcon /></IconButton>
        </Box>

        <Typography variant="subtitle1" gutterBottom sx={{mb:1}}>
          {/* Absence ID: {selectedUpload?.id} */}
          Employee: {selectedUpload?.employee.firstName} {selectedUpload?.employee.lastName}
        </Typography>

        <TextField
          fullWidth
          label={leave? 'Description' : 'Reason'}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={3}
          sx={{ mb: 2 }}
          disabled={leave}
        />

        <Button
          variant="contained"
          component="label"
          fullWidth
          startIcon={<UploadIcon />}
          sx={{ mb: 2 }}
        >
          Upload File
          <input
            type="file"
            hidden
            onChange={handleFileChange}
          />
        </Button>

        {file && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Selected: {file.name}
          </Typography>
        )}

        {error && (
          <Typography color="error" sx={{ mb: 1 }}>
            {error}
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          fullWidth
          disabled={submitting}
        >
          {submitting ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
        </Button>
      </Box>
    </Modal>
  );
};

export default JustificationUploadModal;
